import {ICampaign} from 'interfaces/Index'
import { convertCampaignDate } from 'utils/lib';

export const normalizeCampaignData = (campaigns: ICampaign[]): ICampaign[] => {
    const normalizedCampaigns = campaigns.map((campaign) => {
      const obj = Object.assign({}, campaign, {
        startDate: convertCampaignDate(campaign.startDate),
        endDate: convertCampaignDate(campaign.endDate),
      });
      return obj;
    });

    return normalizedCampaigns;
  };